module.exports = __webpack_public_path__ + "images/moonshot/background-right.dccbe85a966a282963f0.svg";